import submitbtn from "../assets/images/submit.svg";

function CustomButton(props) {
  const {
    title = "",
    handleClick = () => { },
    isLoading = false,
    isDisabled = false,
    isIcon = false,
    src = "",
    className = "",
    style = {}
  } = props;

  return (
    <button
      className={`btnVldt ${className}  ${isDisabled ? "disabled" : ""}`}
      onClick={handleClick}
      disabled={isDisabled || isLoading}
      style={style}
    >
      <div
        className={`d-flex align-items-center justify-content-center gap-2 ${isLoading ? "invisible" : ""
          }`}
      >
        <p className="mb-0" style={{ color: "white", opacity: 1 }}>
          {title}
        </p>
        {isIcon && <img src={src} alt="arrow" className="arrowIconStyl" />}
      </div>
      {isLoading && (
        <span
          className="spinner-border text-light spinner-border-sm position-absolute"
          role="status"
          aria-hidden="true"
        ></span>
      )}
    </button>
  );
}

export default CustomButton;
